import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { fetchOrgSettingsRequest, updateOrgSettingsRequest } from '../../../api/organizations/orgSlice';
import {
  Box,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ReportsEmailSettings = () => {
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.org);

  const [reportsEmailPreference, setReportsEmailPreference] = useState({
    send_email_on_completion: false,
  });

  const {
    handleSubmit: validateEmail,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  });

  useEffect(() => {
    dispatch(fetchOrgSettingsRequest());
  }, [dispatch]);

  useEffect(() => {
    if (settings?.reports_generation_notification) {
      setReportsEmailPreference({
        ...settings.reports_generation_notification,
      });
    }
  }, [settings]);

  const handleSubmit = (updated = {}) => {
    dispatch(
      updateOrgSettingsRequest({
        updates: {
          reports_generation_notification: {
            ...reportsEmailPreference,
            ...updated,
          },
        },
      }),
    );
  };

  const handleToggleChange = (field) => {
    const updated = { ...reportsEmailPreference, [field]: !reportsEmailPreference[field] };
    setReportsEmailPreference(updated);
    handleSubmit(updated);
  };

  return (
    <Paper elevation={0} sx={{ mt: 5 }}>
      <Typography variant="h6" sx={{ mb: '1.5rem' }}>
        Reports Completion Notifications
        <Divider />
      </Typography>

      <Grid container>
        <Grid size={4.5}>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={reportsEmailPreference.send_email_on_completion}
                  onChange={() => handleToggleChange('send_email_on_completion')}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {'Send Email on Report Completion'}
                  <Tooltip title="When enabled, the user who initiated the report download and the root user will be notified via email once the job has finished processing.">
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              labelPlacement="start"
              sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ReportsEmailSettings;
